import * as React from 'react';
import PropTypes from 'prop-types';
import { isBrowser } from '../../youwell-common/browserUtils';
import { datestamp, getAge } from '../../youwell-common/dateUtils';

const valueFromCommonVariables = (key, patientData, patientProgram) => {
    switch (key) {
    case 'patient_name': return patientData?.name;
    case 'patient_age': return getAge(patientData?.birthDate);
    case 'program_name': return patientProgram?.program?.name;
    case 'program_start': return datestamp(patientProgram?.startDate);
    default: return null;
    }
}

class ContentVariableLoader extends React.Component {
    componentDidMount() {
        if (isBrowser) {
            // eslint-disable-next-line no-underscore-dangle
            window.__getYouwellVariable = this.getYouwellVariable;
        }
    }

    componentWillUnmount() {
        if (isBrowser) {
            // eslint-disable-next-line no-underscore-dangle
            window.__getYouwellVariable = null;
        }
    }

    getYouwellVariable = (variableName) => {
        const { currentProgram, patientData, showVariableNameIfNull, customVariables } = this.props;

        let value = customVariables?.[variableName];

        if (!value) {
            value = valueFromCommonVariables(variableName, patientData, currentProgram);
        }

        if (!value) {
            value = currentProgram?.settings?.keyValues?.[variableName];
        }

        if (!value) {
            value = showVariableNameIfNull ? `[${variableName}]` : '';
        }

        return value;
    }

    render() {
        return null;
    }
}

ContentVariableLoader.propTypes = {
    patientData: PropTypes.object,
    currentProgram: PropTypes.object,
    showVariableNameIfNull: PropTypes.bool,
    customVariables: PropTypes.object,
};

ContentVariableLoader.defaultProps = {
    patientData: null,
    currentProgram: null,
    showVariableNameIfNull: false,
    customVariables: null,
};

export default ContentVariableLoader;
